import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class MachineMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: MachineMetaModule,
            providers: [
                providePageMeta({
                    title: 'Machines',
                    translationKey: 'page_machines',
                    routerLink: '/machines',
                    sidebarSection: 'Management',
                    svgIcon: 'uipath:machines',
                    permission: 'Machines.View',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 3,
                }),
            ],
        };
    }
}
